import { FC } from 'react';
import { getBookingStatus } from '../../../../constants/bookingStatus';

interface BookingStatusBadgeProps {
  status: number;
  className?: string;
}

const BookingStatusBadge: FC<BookingStatusBadgeProps> = ({
  status,
  className = '',
}) => {
  const statusInfo = getBookingStatus(status);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusInfo.color} ${className}`}
    >
      {statusInfo.label}
    </span>
  );
};

export default BookingStatusBadge;
